import React, { PropTypes } from 'react'
import styles from './styles'
import classNames from 'classnames'

const CornerTriangle = props =>
  <div className={classNames(styles.cornerTriangle, { [styles.show]: props.show })} />

CornerTriangle.propTypes = { show: PropTypes.bool }

export default CornerTriangle



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/cornerTriangle.jsx